import { LOCK_HOME_PLAN_PREP_TOOLTIP } from "lib/constants/messages";
import Link from "ui/components/Link";
import IconLocked from "ui/icons/IconLocked";
import styles from "./LockHomePlanButton.module.scss";

interface LockHomePlanButtonProps {
  handleClick: () => void;
  lockable: boolean;
  /** Overrides the default "cannot lock in Plan Preparation" tooltip shown when `lockable` is false. */
  tooltip?: string;
}

export default function LockHomePlanButton({
  handleClick,
  lockable,
  tooltip = LOCK_HOME_PLAN_PREP_TOOLTIP,
}: LockHomePlanButtonProps) {
  return (
    <Link
      key="lock_plan"
      disabled={!lockable}
      className={styles.lockButton}
      tooltip={!lockable ? tooltip : undefined}
      onClick={handleClick}
    >
      <IconLocked variant="portal" size={14} />
      Lock Home Plan
    </Link>
  );
}
